module.exports = __webpack_public_path__ + "static/media/imge-3.ec511897.jpg";